import { createStyles } from '@material-ui/core';
import { border, toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    container: {
        background: theme.color.background.light,
    },
    checkBox: {
        color: 'inherit',
    },
    filterSection: {
        borderRight: '1px solid',
        '&:last-child': {
            borderRight: 0,
        },
        width: 'auto',
    },
    filterTitle: {
        borderBottom: border(theme.color.grey.default),
        padding: toCssValue([theme.space.padding.smallest * 3, theme.space.padding.small]),
        color: theme.color.grey.default,
    },
    filterItem: {
        padding: toCssValue([0, theme.space.padding.small]),
    },
    icon: {
        color: 'currentColor',
        fontSize: 16,
        height: 16,
        lineHeight: 1,
        top: 1,
        transition: 'transform 0.3s',
        width: 16,
    },
    iconActive: {
        transform: 'scaleY(-1)',
    },
    iconContainer: {
        marginLeft: 'auto',
        padding: '0 10px',
        marginTop: '-5px',
    },
    customIconContainer: {
        marginLeft: 'auto',
    },
});
export default styles;
//# sourceMappingURL=DataTableToolbarStyles.js.map